import { Permission, SCHEDULE_APP_MANAGEMENT, WFM_APP_MANAGEMENT } from './permissions.constants'
import { ROUTE_PATH_REGEX, ROUTE_PATHS_PREFIX } from '../page.constants'

export const AGENT_EXPLORER: readonly Permission[] = [
  'ViewDesktopAnalytics',
]

export const AGENT_DYNAMIC_SCHEDULING: readonly Permission[] = [
]

export const ANALYTICS: readonly Permission[] = [
  'SystemMetrics',
  'ViewAdvancedAnalytics',
  'ViewAudioAnalytics',
  'ViewDesktopAnalytics',
  'ViewLvcsrAnalytics',
  'ViewSystemAnalytics',
  'ViewTextAnalytics',
  'ViewTrendingTopics',
  'AutoQADashboardsView',
  'SmartTagView',
]

export const MANAGE_LANDING_PAGES: readonly Permission[] = [
  'AssignRoles',
]

export const APPLICATION_MANAGEMENT: readonly Permission[] = [
  'ViewOrg',
  'ViewTenant',
  'UpdateTenant',
  'QMAppManagement',
  'WFMAppManagement',
  'CreateRoles',
  'LiveMonitoring',
  'AdministerTenantIT',
  'AdministerAnalyticsSettings',
  'SystemMetrics',
  'CreateSystemLicense',
  'ScheduleAppManagement',
]

export const QM_GLOBAL_SETTINGS: readonly Permission[] = [
  'QMAppManagement',
]

export const DEVICE_ASSOCIATIONS: readonly Permission[] = [
  'ViewDeviceConfig',
]

export const INCLUSION_EXCLUSION: readonly Permission[] = [
]

export const EVALUATION_FORM_GROUPS: readonly Permission[] = [
  'EvaluationForm',
]

export const BULK_CONTACT_OPERATIONS: readonly Permission[] = [
  'BulkDelete',
  'BulkUpdateRetention',
  'BulkUpdateMetadata',
]

export const EVALUATION_FORM_MANAGER: readonly Permission[] = [
  'EvaluationForm',
]

export const ANALYTICS_MAIL_SERVER: readonly Permission[] = [
  'UpdateTenant',
]

export const OUTGOING_MAIL_SERVER: readonly Permission[] = [
  'UpdateTenant',
]

export const ANALYTICS_SUBSTITUTION: readonly Permission[] = [
  'AdminLvcsrAnalytics',
]

export const CONTACT_QUEUE: readonly Permission[] = [
  'ViewContactGoal',
]

export const DASHBOARD: readonly Permission[] = [
  'AdministerDashboard',
  'ViewQMDashboard',
  'ViewWFMDashboard',
  'DataExplorer',
  'ViewBIHome',
]

export const ASSET_BROWSER: readonly Permission[] = [
  'ReportAuthoring',
  'ViewBIContent',
]

export const MESSAGING: readonly Permission[] = [
  'AdministerMessaging',
  'UpdateMessagingRequests',
]

export const RECORDING_CONTROLS: readonly Permission[] = [
  'PauseResumeCommandUI',
  'LoginLogoutCommandUI',
  'AddMetadataCommandUI',
  'TagCommandUI',
  'StartStopSegmentCommandUI',
  'StartStopScreenCommandUI',
]

export const RECORDINGS: readonly Permission[] = [
  'SearchContacts',
  'SearchScoredContacts',
]

export const REPORTS: readonly Permission[] = [
  'QMReports',
  'WFMReports',
  'AdministerWFMReports',
  'AdministerQMReports',
  'SupervisorWFMReports',
]

export const APIDOCUMENTATION: readonly Permission[] = [
  'ViewAPIDocumentation',
  'UpdateTenant',
]

export const SCHEDULE: readonly Permission[] = [
  'ViewSchedules',
  'EditSchedules',
  'PlanSchedules',
]

export const TEAMS: readonly Permission[] = [
  'UpdateTeam',
]

export const VIEW_SCHEDULES: readonly Permission[] = [
  'ViewSchedules',
]

export const EDIT_SCHEDULES: readonly Permission[] = [
  'EditSchedules',
]

export const PLAN_SCHEDULES: readonly Permission[] = [
  'PlanSchedules',
]

export const SCHEDULE_CHANGE_MANAGEMENT: readonly Permission[] = [
  'WFMAppManagement',
  'ScheduleAppManagement',
]

export const CCAAS_CONFIGURATION: readonly Permission[] = [
  'AdministerACDConfiguration',
]

export const BULK_CONTACT_EXPORT_MONITORING: readonly Permission[] = [
  'BulkContactExport',
  'ViewBulkContactExport',
]

export const TRANSCRIPTION_SEARCH: readonly Permission[] = [
  'ViewLvcsrAnalytics',
]

export const PHRASE_MANAGER: readonly Permission[] = [
  'AdminPhrases',
  'SmartTagEditorView',
]

export const ANALYTICS_CONFIGURATION: readonly Permission[] = [
  'AdminAudioAnalytics',
  'AdminDesktopAnalytics',
  'AdminLvcsrAnalytics',
  'AdminTextAnalytics',
]

export const TASK_MANAGER: readonly Permission[] = [
  'AdminAudioAnalytics',
  'AdminDesktopAnalytics',
  'AdminLvcsrAnalytics',
  'AdminTextAnalytics',
  'AdminPredictiveAnalytics',
  'TrendingTopicsRunTask',
  'AutoQARunTask',
  'SentimentRunTask',
  'SmartTagRunTask',
]
export const LEGACY_API_ACCESS: readonly Permission[] = [
  'UpdateOrg',
]

export const IAM_INTEGRATION: readonly Permission[] = [
  'UpdateTenant',
]

export const CUSTOMER_IDP_CONFIG: readonly Permission[] = [
  'AdministerTenantIT',
]

export const PERFORMANCE_COACHING: readonly Permission[] = [
  'AmplifAIPerformanceUser',
  'AmplifAICoachUser',
  'AmplifAIObserverUser',
  'AmplifAISysAdminUser',
]

// Performance Coaching permissions
export const PERFORMANCE_COACHING_AGENT: readonly Permission[] = [
  'AmplifAIPerformanceUser',
]
export const PERFORMANCE_COACHING_COACH: readonly Permission[] = [
  'AmplifAICoachUser',
]
export const PERFORMANCE_COACHING_ORG: readonly Permission[] = [
  'AmplifAIObserverUser',
]
export const PERFORMANCE_COACHING_ADMIN: readonly Permission[] = [
  'AmplifAISysAdminUser',
]

export const CREATE_CDM_CONTENT: readonly Permission[] = [
  'ReportAuthoring',
  'CreateBIContent',
]

export const CDM_SETTINGS: readonly Permission[] = [
  'ReportAuthoring',
  'ManageBIDelivery',
  'ManageBIInfospace',
]

export const VIEW_CDM_DATA_LIBRARY: readonly Permission[] = [
  'ViewBIDataLibrary',
]

export const MANAGE_CDM_CONTENT_DELIVERY: readonly Permission[] = [
  'ManageBIDelivery',
]

export const TIME_OFF_REPORT: readonly Permission[] = [
  'ScheduleAppManagement',
  'WFMAppManagement',
]

export const CDM_DATA_TASK_MANAGEMENT: readonly Permission[] = [
  'AdminBITasks',
]

export const DATA_UDM_CONNECTOR_MANAGEMENT: readonly Permission[] = [
  'AdminBIUDM',
]

export const DATA_RT_CONNECTOR_MANAGEMENT: readonly Permission[] = [
  'AdminBIRT',
]

export const MANAGE_CDM_SHARING_GROUP: readonly Permission[] = [
  'AdministerTenantIT',
  'AdminBISharingGroups',
]

export const BI_INSIGHTS: readonly Permission[] = [
  'BiInsightsViewContent',
  'BiInsightsAdminTenant',
  'BiInsightsAdminSystem',
]

export const BOT_ANALYTICS: readonly Permission[] = [
  'BaViewExperienceAutomation',
  'BaViewConvDistribution',
  'BaViewConvTopics',
  'BaViewImpactAnalysis',
  'BaViewAggregatedMetrics',
  'BaViewTranscriptSearch',
  'BaViewVAAOverview',
  'BaViewVAAPerformanceComparison',
  'BaViewVAAResponsePerformance',
  'BaViewVAAUnclassifiedMessages',
  'BaViewVAAIntentPerformance',
  'BaViewBotManagementReport',
  'BaViewBotPerformanceReport',
]

export const TRENDING_TOPICS: readonly Permission[] = [
  'ViewTrendingTopics',
]

export const AUTO_QA: readonly Permission[] = [
  'AutoQADashboardsView',
]

export const AUTO_QA_INTERACTION: readonly Permission[] = [
  'AutoQAView',
]

export const AUTO_QA_RUN: readonly Permission[] = [
  'AutoQARun',
]

export const SENTIMENT_VIEW: readonly Permission[] = [
  'SentimentView',
]

export const SMART_TAGS: readonly Permission[] = [
  'SmartTagView',
]

export const SMART_TAGS_EDITOR_VIEW: readonly Permission[] = [
  'SmartTagEditorView',
]

export const ADMINISTER_QM_CONTACT_GOALS: readonly Permission[] = [
  'AdministerQMContactGoals',
]

export const SCHEDULE_SCHEDULE_CHANGE_MANAGEMENT: readonly Permission[] = [
  SCHEDULE_APP_MANAGEMENT,
  WFM_APP_MANAGEMENT,
]

export const PAGE_REGEX_PERMISSIONS_MAP: ReadonlyMap<RegExp, readonly Permission[]> = new Map([
  [ROUTE_PATH_REGEX.FIVE9_ARU_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATH_REGEX.BI_INSIGHTS, BI_INSIGHTS],
])

export const PAGE_PERMISSIONS_MAP:  ReadonlyMap<string, readonly Permission[]> = new Map([
  [ROUTE_PATHS_PREFIX.INCLUSION_EXCLUSION, INCLUSION_EXCLUSION],
  [ROUTE_PATHS_PREFIX.ANALYTICS_SUBSTITUTION, ANALYTICS_SUBSTITUTION],
  [ROUTE_PATHS_PREFIX.TASK_MANAGER_CREATE, TASK_MANAGER],
  [ROUTE_PATHS_PREFIX.NEW_TASK_MANAGER, TASK_MANAGER],
  [ROUTE_PATHS_PREFIX.ANALYTICS_CONFIG, ANALYTICS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.DEVICE_ASSOCIATIONS, DEVICE_ASSOCIATIONS],
  [ROUTE_PATHS_PREFIX.PHRASE_MANAGER, PHRASE_MANAGER],
  [ROUTE_PATHS_PREFIX.EVALUATION_FORM_GROUPS, EVALUATION_FORM_GROUPS],
  [ROUTE_PATHS_PREFIX.EVALUATION_FORM_MANAGER, EVALUATION_FORM_MANAGER],
  [ROUTE_PATHS_PREFIX.BULK_CONTACT_OPERATIONS, BULK_CONTACT_OPERATIONS],
  [ROUTE_PATHS_PREFIX.OUTGOING_MAIL_SERVER, OUTGOING_MAIL_SERVER],
  [ROUTE_PATHS_PREFIX.ANALYTICS_MAIL_SERVER, ANALYTICS_MAIL_SERVER],
  [ROUTE_PATHS_PREFIX.QM_GLOBAL_SETTINGS, QM_GLOBAL_SETTINGS],
  [ROUTE_PATHS_PREFIX.GENESYS_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.TEAMS, TEAMS],
  [ROUTE_PATHS_PREFIX.TWILIO_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.UJET_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.CISCO_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.CISCO_WEBEX_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.RING_CENTRAL_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.AVAYA_AXP_PUBLIC_CONFIGURATION, CCAAS_CONFIGURATION],
  [ROUTE_PATHS_PREFIX.LEGACY_API_ACCESS, LEGACY_API_ACCESS],
  [ROUTE_PATHS_PREFIX.IAM_INTEGRATION, IAM_INTEGRATION],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING_SETTINGS, APPLICATION_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.TIME_OFF_REPORT, TIME_OFF_REPORT],
  [ROUTE_PATHS_PREFIX.DATA_TASK_MANAGEMENT, CDM_DATA_TASK_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.USER_ATTRIBUTES_MANAGEMENT, APPLICATION_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.UDM_CONNECTOR_MANAGEMENT, DATA_UDM_CONNECTOR_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.RT_CONNECTOR_MANAGEMENT, DATA_RT_CONNECTOR_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.BULK_CONTACT_EXPORT_MONITORING, BULK_CONTACT_EXPORT_MONITORING],
  [ROUTE_PATHS_PREFIX.AGENT_DYNAMIC_SCHEDULING, AGENT_DYNAMIC_SCHEDULING],
  [ROUTE_PATHS_PREFIX.AGENT_EXPLORER, AGENT_EXPLORER],
  [ROUTE_PATHS_PREFIX.ANALYTICS, ANALYTICS],
  [ROUTE_PATHS_PREFIX.TRANSCRIPTION_SEARCH, TRANSCRIPTION_SEARCH],
  [ROUTE_PATHS_PREFIX.CUSTOMER_IDP_CONFIG, CUSTOMER_IDP_CONFIG],
  [ROUTE_PATHS_PREFIX.CONTACT_QUEUE, CONTACT_QUEUE],
  [ROUTE_PATHS_PREFIX.DASHBOARD, DASHBOARD],
  [ROUTE_PATHS_PREFIX.AR_ASSET_BROWSER, ASSET_BROWSER],
  [ROUTE_PATHS_PREFIX.AR_DATA_LIBRARY, VIEW_CDM_DATA_LIBRARY],
  [ROUTE_PATHS_PREFIX.CDM_SETTINGS, CDM_SETTINGS],
  [ROUTE_PATHS_PREFIX.DATA_EXPLORER, ASSET_BROWSER],
  [ROUTE_PATHS_PREFIX.CDM_SHARING_GROUP_ADMIN, MANAGE_CDM_SHARING_GROUP],
  [ROUTE_PATHS_PREFIX.MESSAGING, MESSAGING],
  [ROUTE_PATHS_PREFIX.RECORDING_CONTROLS, RECORDING_CONTROLS],
  [ROUTE_PATHS_PREFIX.RECORDINGS, RECORDINGS],
  [ROUTE_PATHS_PREFIX.APIDOCUMENTATION, APIDOCUMENTATION],
  [ROUTE_PATHS_PREFIX.REPORTS, REPORTS],
  [ROUTE_PATHS_PREFIX.SCHEDULING_AGENT_SCHEDULES, EDIT_SCHEDULES],
  [ROUTE_PATHS_PREFIX.SCHEDULING_INTRADAY_DYNAMIC_SCHEDULING, PLAN_SCHEDULES],
  [ROUTE_PATHS_PREFIX.SCHEDULING_MY_AVAILABILITY, VIEW_SCHEDULES],
  [ROUTE_PATHS_PREFIX.SCHEDULING_MY_SCHEDULE, VIEW_SCHEDULES],
  [ROUTE_PATHS_PREFIX.SCHEDULING_PLANNING, PLAN_SCHEDULES],
  [ROUTE_PATHS_PREFIX.SCHEDULING_SCHEDULE_CHANGE_MANAGEMENT, SCHEDULE_SCHEDULE_CHANGE_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.SCHEDULING, SCHEDULE],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING_ADMIN_DASHBOARD, PERFORMANCE_COACHING_ADMIN],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING_COACH_DASHBOARD, PERFORMANCE_COACHING_COACH],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING_ORG_DASHBOARD, PERFORMANCE_COACHING_ORG],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING_AGENT_DASHBOARD, PERFORMANCE_COACHING_AGENT],
  [ROUTE_PATHS_PREFIX.PERFORMANCE_COACHING, PERFORMANCE_COACHING],
  [ROUTE_PATHS_PREFIX.BI_INSIGHTS, BI_INSIGHTS],
  [ROUTE_PATHS_PREFIX.LANDINGPAGE_MANAGEMENT, MANAGE_LANDING_PAGES],
  [ROUTE_PATHS_PREFIX.TRANSFER_USER_DATA, APPLICATION_MANAGEMENT],
  [ROUTE_PATHS_PREFIX.BOT_ANALYTICS, BOT_ANALYTICS],
  [ROUTE_PATHS_PREFIX.TRENDING_TOPICS, TRENDING_TOPICS],
  [ROUTE_PATHS_PREFIX.AUTO_QA, AUTO_QA],
  [ROUTE_PATHS_PREFIX.AUTO_QA_FORM_MANAGER, AUTO_QA_RUN],
  [ROUTE_PATHS_PREFIX.SMART_TAGS, SMART_TAGS],
  [ROUTE_PATHS_PREFIX.CONTACT_GOAL_ADMIN, ADMINISTER_QM_CONTACT_GOALS],
  [ROUTE_PATHS_PREFIX.APPLICATION_MANAGEMENT, APPLICATION_MANAGEMENT],
])
